import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'facs_average_monthly_volume_numerical_amount'

export const dataPointDefinition = {
  retracedId: 'facs_average_monthly_volume_numerical_amount',
  name: "Facility's average monthly volume (numerical amount):",
  description: 'Calculate the average based on the 12-month assessment period. ',
  meta: {},
  fieldTypeId: 'NUMBER',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'number',
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'fp-pi-10',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 3810,
  sectionId: '1.3',
  impactArea: 'Operational Metrics',
  impactAreaId: 'OPERATIONAL_METRICS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
